import { render, staticRenderFns } from "./PackageKidDetailDialog.vue?vue&type=template&id=c862d45e&scoped=true"
import script from "./PackageKidDetailDialog.vue?vue&type=script&lang=js"
export * from "./PackageKidDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./PackageKidDetailDialog.vue?vue&type=style&index=0&id=c862d45e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c862d45e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c862d45e')) {
      api.createRecord('c862d45e', component.options)
    } else {
      api.reload('c862d45e', component.options)
    }
    module.hot.accept("./PackageKidDetailDialog.vue?vue&type=template&id=c862d45e&scoped=true", function () {
      api.rerender('c862d45e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Package/PackageKidDetailDialog.vue"
export default component.exports